import React from 'react';

// Packages
import { Button, Col, Container, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Components
import TablePagination from '../../../utils/TablePagination';

const GlobalConfigTable = props => {
	const { tableLoading, dataCount, tableData, start, setStart, end, setEnd, limit } = props;

	const nPages = Math.ceil(dataCount / limit);

	return (
		<div>
			<Table responsive>
				<thead style={{backgroundColor: '#e7f1ff'}}>
					<tr>
						<th>Id</th>
						<th>Organization</th>
						<th>App</th>
						<th>Language</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{tableLoading 
						?	<tr>
								<td className='text-center' colSpan={9}>
									<Container className='d-flex align-items-center justify-content-center' style={{ height: '5rem' }}>
										<Spinner animation='border' style={{ width: '2.5rem', height: '2.5rem', color: '#004982' }} />
									</Container>
								</td>
							</tr>
						:	tableData.length > 0
							?	tableData.map((config) => (
									<tr key={config?._id?.$oid}>
										<td>{config?._id?.$oid}</td>
										<td>{config?.organization?.name}</td>
										<td>{config?.app?.name}</td>
										<td>{config?.language?.name}</td>
										<td>
											<Row>
												<Col>
													<OverlayTrigger
														placement='top'
														overlay={<Tooltip id='button-tooltip-2'>Info</Tooltip>}
													>
														<Button
															type='button'
															className='jobs-actions me-2'
															onClick={() => window.open(`/global-config/${config?._id?.$oid}/info`, '_self')}
														>
															<i className='bi bi-eye-fill fs-5'></i>
														</Button>
													</OverlayTrigger>
												</Col>
											</Row>
										</td>
									</tr>
								))
							:	<tr>
									<td className='text-center' colSpan={9}>No configurations found</td>
								</tr>
					}
				</tbody>
			</Table>
			<TablePagination
				count={dataCount}
				arrayLength={tableData.length}
				nPages={nPages}
				start={start}
				setStart={setStart}
				end={end}
				setEnd={setEnd}
				limit={limit}
			/>
		</div>
	)
}

GlobalConfigTable.propTypes = {
	tableLoading: PropTypes.bool.isRequired,
	dataCount: PropTypes.number.isRequired,
	tableData: PropTypes.array.isRequired,
	start: PropTypes.number.isRequired,
	setStart: PropTypes.func.isRequired,
	end: PropTypes.number.isRequired,
	setEnd: PropTypes.func.isRequired,
	limit: PropTypes.number.isRequired
}

export default GlobalConfigTable;
